import { LORAX, LORAX_LIGHT } from 'HubStyleTokens/colors';
import styled from 'styled-components';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITile from 'UIComponents/tile/UITile';
import UITileSection from 'UIComponents/tile/UITileSection';
import UIList from 'UIComponents/list/UIList';
import { AppPersonalizationTitle } from './AppPersonalizationTitle';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledAppPersonalizationTile = styled(UITile).withConfig({
  displayName: "AppPersonalizationVariant1__StyledAppPersonalizationTile",
  componentId: "gci1cv-0"
})(["background-color:", ";border-color:", ";padding:8px 0;> *{padding:8px 8px 8px 20px;display:flex;}h6{line-height:1;padding:4px;}ul{padding-left:20px;}"], LORAX_LIGHT, LORAX);
export const AppPersonalizationVariant1 = ({
  appPersonalizationInstallStats
}) => {
  return /*#__PURE__*/_jsxs(StyledAppPersonalizationTile, {
    compact: true,
    "data-test-id": "conv-0002-variant1",
    children: [/*#__PURE__*/_jsx(AppPersonalizationTitle, {}), /*#__PURE__*/_jsx(UITileSection, {
      children: /*#__PURE__*/_jsx(UIList, {
        styled: true,
        childClassName: "m-y-1",
        firstChildClassName: "",
        lastChildClassName: "",
        children: Object.keys(appPersonalizationInstallStats).map(stat => {
          const statKey = stat; // have to force the type here
          if (!appPersonalizationInstallStats[statKey]) {
            return null;
          }
          const count = Object.values(appPersonalizationInstallStats[statKey])[0] || 0;
          const value = Object.keys(appPersonalizationInstallStats[statKey])[0];
          return /*#__PURE__*/_jsx("span", {
            "data-test-id": `app-personalization-${stat}-stat`,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `appMarketplace.detail.overview.sidebar.appPersonalization.${statKey}`,
              options: {
                count: I18n.formatNumber(Math.floor(count / 10) * 10),
                value
              }
            })
          }, stat);
        })
      })
    })]
  });
};